<script>
import { mapActions, mapMutations } from 'vuex';
/* import carousel from 'vue-owl-carousel' */
import request from '../services/request'

import Multiselect from 'vue-multiselect'

import StarRating from 'vue-star-rating'
// import LoadPageComponent from '@/components/LoadPageComponent.vue';

/* import galeryOffice from '@/components/GaleryOfficeComponent.vue' */

export default {
    components: {
        /* carousel,
        galeryOffice, */
        Multiselect,
        StarRating
    },
    data() {
        return {
            id:'',
            booking_id:'',
            booking: null,
            office: {},
            form: {},
            send_assistant: false,
            estructure_survey: [
                {
                    question: 'La sala es adecuada para llevar la sesión (Espacio, Iluminación, Temperatura, Limpieza, Mobiliario en buen estado).',
                    quality: 0,
                },
                {
                    question: 'El expositor tiene los conocimientos y actitud adecuada para impartir.',
                    quality: 0,
                },
                {
                    question: 'Los conocimientos y datos compartidos son útiles para mi puesto.',
                    quality: 0,
                },
                {
                    question: 'Los materiales utilizados para exponer son claros y legibles.',
                    quality: 0,
                },
                {
                    question: 'Recomendarías tomar esta sesión a tus compañeros o colaboradores',
                    quality: 0,
                },
            ],
            estructure_survey_virtual: [
                {
                    question: 'El expositor tiene el conocimiento suficiente para impartir esta sesión.',
                    quality: 0,
                },
                {
                    question: 'El expositor explica de forma dinámica, amable y respetuosa la información.',
                    quality: 0,
                },
                {
                    question: 'Los conocimientos y datos compartidos son útiles para mi puesto.',
                    quality: 0,
                },
                {
                    question: 'Los materiales utilizados para exponer son claros y legibles.',
                    quality: 0,
                },
                {
                    question: 'Recomendarías tomar esta sesión a tus compañeros o colaboradores',
                    quality: 0,
                },
            ],
            internal_group: null,
            options_groups: [
                {
                    id: 1,
                    title: 'SI',
                },
                {
                    id: 2,
                    title: 'NO',
                }
            ],
            business: null,
            options_business: [
                {
                    id: 1,
                    title: 'PRESTA PRENDA',
                },
                {
                    id: 2,
                    title: 'FORMATOS PROPIOS',
                },
                {
                    id: 3,
                    title: 'FORMATOS DE TERCEROS',
                },
                {
                    id: 4,
                    title: 'STAFF',
                },
                {
                    id: 5,
                    title: 'CAPITAL HUMANO',
                },
            ],
            division: null,
            territory: null,
            locations: [
                {
                    id: 1,
                    title: 'DIVISIÓN CENTRO',
                    territories: [
                        {
                            id: 1,
                            title: 'METRO CENTRO',
                        },
                        {
                            id: 2,
                            title: 'METRO FORANEA',
                        },
                        {
                            id: 3,
                            title: 'METRO NORTE',
                        },
                        {
                            id: 4,
                            title: 'METRO ORIENTE'
                        },
                        {
                            id: 5,
                            title: 'METRO PONIENTE'
                        },
                        {
                            id: 6,
                            title: 'METRO SUR'
                        },
                        {
                            id: 7,
                            title: 'QUERETARO'
                        },
                    ],
                },
                {
                    id: 2,
                    title: 'DIVISIÓN NORTE',
                    territories: [
                        {
                            id: 8,
                            title: 'BAJA CALIFORNIA NORTE',
                        },
                        {
                            id: 9,
                            title: 'BAJA CALIFORNIA SUR',
                        },
                        {
                            id: 10,
                            title: 'BAJIO',
                        },
                        {
                            id: 11,
                            title: 'CHIHUAHUA'
                        },
                        {
                            id: 12,
                            title: 'JALISCO'
                        },
                        {
                            id: 13,
                            title: 'NUEVO LEÓN'
                        },
                        {
                            id: 14,
                            title: 'SAN LUIS POTOSÍ'
                        },
                        {
                            id: 15,
                            title: 'SINALOA'
                        },
                    ],
                },
                {
                    id: 3,
                    title: 'DIVISIÓN SUR',
                    territories: [
                        {
                            id: 16,
                            title: 'CHIAPAS',
                        },
                        {
                            id: 17,
                            title: 'GUERRERO',
                        },
                        {
                            id: 18,
                            title: 'MICHOACÁN',
                        },
                        {
                            id: 19,
                            title: 'OAXACA'
                        },
                        {
                            id: 20,
                            title: 'PUEBLA'
                        },
                        {
                            id: 21,
                            title: 'TABASCO'
                        },
                        {
                            id: 22,
                            title: 'VERACRUZ'
                        },
                        {
                            id: 23,
                            title: 'YUCATÁN'
                        },
                    ],
                },
            ],
            imagesFiles: [],
            error: {
                score: false
            },
            baseFiles: this.$BaseUrlFiles,
            send: false,
            sending: false,
        }
    },
    created() {
        this.resetForm();
    },
    methods: {
        
        resetForm() {
            this.form.id = '';
            this.form.internal_group = '';
            this.form.code_user = '';
            this.form.name = '';
            this.form.first_last_name = '';
            this.form.second_last_name = '';
            this.form.division = '';
            this.form.territory = '';
            this.form.business = '';
            this.form.work_position = '';
            this.form.region = '';
            this.form.sale_point = '';
            this.form.name_sale_point = '';
            this.form.activity = '';
            this.form.instructor = '';
        },
        getSurvey(room) {
            if (room && room.room_type_id == 3) {
                return this.estructure_survey_virtual;
            }else{
                return this.estructure_survey;
            }
        },
        async get_office(time = 1) {
            let service = request;
            // let _endpoint = `/booking/list/${this.id}`;
            this.setRouteChange(true);
            let _endpoint = `/public/booking_assistant/${this.id}`;
            try {
                let { data } = await service.get(_endpoint);
                if (data) {
                    console.log(data.data);
                    this.booking = data.data;
                    this.booking_id = data.data ? data.data.id : null;
                    this.office = data.data ? data.data.room : null;
                    this.form.room_id = this.office ? this.office.id : null;
                    this.form.booking_id = data.data ? data.data.id : null;

                    if(!this.booking_id){
                        setTimeout(() => {
                            this.$router.push({ name: 'home' });
                        }, 3000);
                    }
                    setTimeout(() => {
                        this.setRouteChange(false);
                    }, 2000);
                }
            } catch (error) {
                this.errors = await this.errorNotification(error)
                if(time < 3) {
                    setTimeout(() => {
                        this.get_office(time + 1);
                    }, 2000);
                } else {
                    this.$router.push({ name: 'home' });
                }
                this.setRouteChange(false);
            }
        },
        async sendAssistant() {
            let vm = this;
            this.send = true;

            this.$swal({
                title: 'Enviar Asistencia',
                text: 'No podrás editar la asistencia',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#5c5c5c',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    if (result) {
                        this.setRouteChange(true);
                        try {
                            let service = request;
                            let _endpoint = `/public/assistant_save/${this.booking_id}`
                            vm.extractIds();
                            let dataForm = new FormData();
                            const keys = Object.keys(vm.form);
                            console.log(keys);
                            keys.forEach(function (valor) {
                                dataForm.append(valor, vm.form[valor]);
                            });

                            dataForm.append('survey', JSON.stringify(vm.estructure_survey));

                            let { data } = await service.postMedia(_endpoint, dataForm);
                            if (data) {
                                this.send = false;
                                await this.successNotification('Éxito al guardar la asistencia.');
                                // this.$router.push({ name: 'home' });
                                vm.send_assistant = true;

                            }
                        } catch (error) {
                            this.send = false;
                            this.errors = await this.errorNotification(error)
                        }
                        this.setRouteChange(false);
                    }
                } else {
                    this.send = false;
                }
            });
        },
        async extractIds() {
            const vm = this;
            vm.form.division = vm.division ? vm.division.title : null;
            vm.form.territory = vm.territory ? vm.territory.title : null;
            vm.form.business = vm.business ? vm.business.title : null;
            vm.form.internal_group = vm.internal_group ? vm.internal_group.title : null;
        },
        onChange() {
            this.$forceUpdate();
        },
        ...mapMutations({
            setHeaderTitle: 'setHeaderTitle',
            setRouteChange: 'setRouteChange',
        }),
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            errorNotificationMessage: 'alert/errorMessage',
            successNotification: 'alert/success',
            authLoginWithTokenReport: "auth/authLoginWithTokenReport",
        }),
    },
    async mounted() {
        this.setHeaderTitle(`Asistencia`);
        this.id = this.$route.params.id;
        if (this.id) {
            await this.get_office();
        }
    },
    watch: {
        comment(newValue) {
            console.log(newValue);
            this.$forceUpdate();
        },
    },
}
</script>
<template>
    <div class="container p-4">
        <div class="row" v-if="booking && !send_assistant">
            <div class="col-12">
                <div class="row mt-3">
                    <div class="col-12">
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>RESERVACIÓN: </b>{{ booking.reservation_number }}
                        </p>
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>CURSO: </b>{{ booking.course ? booking.course.name : '' }} {{ booking.course_other ? ' - ' + booking.course_other : '' }}
                        </p>
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>CENTRO DE EXPERIENCIA: </b>{{ office.name }}
                        </p>

                    </div>
                </div>

                <!-- Cards -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-12 mt-4 mb-4 text-center">
                                <hr>
                            </div>
                            <form @submit.prevent="sendAssistant" v-if="sending == false">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <h4>Gracias por marcar tu asistencia</h4>
                                        </div>
                                        <div class="col-12 mt-3">
                                            <h5>EMPLEADO DE GRUPO ELEKTRA</h5>
                                            <multiselect 
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para eliminar"
                                                v-model="internal_group"
                                                label="title"
                                                placeholder="Escribe para buscar"
                                                :options="options_groups">
                                                <span slot="noResult">No se encontraron opciones con este nombre.</span>
                                            </multiselect>
                                        </div>
                                        <div class="col-12 col-lg-6 mt-3" v-if="internal_group && internal_group.title == 'SI'">
                                            <h5>NÚMERO DE EMPLEADO</h5>
                                            <input type="text" class="form-control" v-model="form.code_user" required placeholder="NUMERO DE EMPLEADO">
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'NO'" class="col-12 col-lg-6 mt-3">
                                            <h5>NEGOCIO</h5>
                                            <input type="text" class="form-control" v-model="form.business" required placeholder="NEGOCIO">
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'NO'" class="col-12 col-lg-6 mt-3">
                                            <h5>PUESTO</h5>
                                            <input type="text" class="form-control" v-model="form.work_position" required placeholder="PUESTO DE TRABAJO">
                                        </div>
                                        <div  class="col-12 col-lg-6 mt-3">
                                            <h5>NOMBRE(S)</h5>
                                            <input type="text" class="form-control" v-model="form.name" required placeholder="Primer y Segundo Nombre">
                                        </div>
                                        <div class="col-12 col-lg-6 mt-3">
                                            <h5>PRIMER APELLIDO</h5>
                                            <input type="text" class="form-control" v-model="form.first_last_name" required placeholder="Primer Apellido">
                                        </div>
                                        <div class="col-12 col-lg-6 mt-3">
                                            <h5>SEGUNDO APELLIDO</h5>
                                            <input type="text" class="form-control" v-model="form.second_last_name" required placeholder="Segundo Apellido">
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'SI'" class="col-12 col-lg-6 mt-3">
                                            <h5>SELECCIONA TU DIVISIÓN</h5>
                                            <multiselect 
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para eliminar"
                                                v-model="division"
                                                label="title"
                                                value="id"
                                                placeholder="Escribe para buscar"
                                                :options="locations">
                                                <span slot="noResult">No se encontraron divisiones con este nombre.</span>
                                            </multiselect>
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'SI'" class="col-12 col-lg-6 mt-3">
                                            <h5>SELECCIONA TU TERRITORIO</h5>
                                            <multiselect 
                                                v-if="division"
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para eliminar"
                                                v-model="territory"
                                                label="title"
                                                value="id"
                                                placeholder="Escribe para buscar"
                                                :options="division.territories">
                                                <span slot="noResult">No se encontraron territorios con este nombre.</span>
                                            </multiselect>
                                            <div class="row text-center" v-else>
                                                <!-- <i class="fa-solid fa-circle-notch text-secondary fa-spin fa-2x"
                                                    style="margin: 0 auto;"></i> -->
                                                    <input type="text" class="form-control" readonly placeholder="Selecciona la division">
                                            </div>
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'SI'" class="col-12 col-lg-6 mt-3">
                                            <h5>NEGOCIO</h5>
                                            <multiselect 
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para eliminar"
                                                v-model="business"
                                                label="title"
                                                value="id"
                                                placeholder="Escribe para buscar"
                                                :options="options_business">
                                                <span slot="noResult">No se encontraron negocios con este nombre.</span>
                                            </multiselect>
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'SI'" class="col-12 col-lg-6 mt-3">
                                            <h5>REGIÓN</h5>
                                            <input type="text" class="form-control" v-model="form.region" required placeholder="Escribe la Región">
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'SI'" class="col-12 col-lg-6 mt-3">
                                            <h5>NÚMERO DE TU SUCURSAL(CECO)</h5>
                                            <input type="text" class="form-control" v-model="form.sale_point" required placeholder="Escribe número de tu sucursal">
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'SI'" class="col-12 col-lg-6 mt-3">
                                            <h5>NOMBRE DE TU SUCURSAL</h5>
                                            <input type="text" class="form-control" v-model="form.name_sale_point" required placeholder="Escribe nombre de tu sucursal">
                                        </div>
                                        <div v-if="internal_group && internal_group.title == 'NO'" class="col-12 col-lg-6 mt-3">
                                            <h5>SESIÓN/ACTIVIDAD</h5>
                                            <input type="text" class="form-control" v-model="form.activity" required placeholder="Escribe la actividad">
                                        </div>
                                        <div class="col-12 mt-3">
                                            <h5>NOMBRE DEL INSTRUCTOR/PONENTE</h5>
                                            <input type="text" class="form-control" v-model="form.instructor" required placeholder="Escribe el nombre del instructor">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 mt-3">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <hr>
                                            <h5>Encuesta de satisfacción</h5>
                                        </div>
                                        <div class="col-12 col-lg-6 mt-3 px-4" v-for="(survey, index_survey) in getSurvey(booking.room)"
                                            :key="index_survey">
                                            <h6>{{ survey.question }}</h6>
                                            <star-rating v-model="survey.quality" />
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-12 mt-3">
                                    <button v-if="form.id == ''" :disabled="send"
                                        class="btn btn-lg btn-danger float-right pl-5 pr-5" style="border-radius: 30px;">
                                        <i v-if="send" class="fa-solid fa-circle-notch fa-spin mr-2"></i>
                                        <span v-if="send">Enviando</span>
                                        <span v-else>Enviar asistencia</span>
                                    </button>
                                </div>
                            </form>
                            <div class="row" v-else>

                                <div class="col-12 text-center p-4">
                                    <div class="card">
                                        <div class="card-body">
                                            <i class="fa-regular fa-circle-check text-red fa-5x"></i>
                                            <h3 class="mt-4 text-secondary"> Tu asistencia ha sido registrada</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="!send_assistant && !booking" class="row">
            <div class="col-12">
                <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                    <span class="animate animate__pulse">Esperando información de la reservación...</span>
                </p>
            </div>
        </div>
        <div v-if="send_assistant && booking" class="w-100 h-100 d-flex justify-content-center align-items-center">
            <div class="text-center">
                <h2 class="text-danger">Tu asistencia ha sido registrada</h2>
                <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                    ¡Gracias por tu participación!
                </p>
            </div>
        </div>
    </div>
</template>
<style scoped>
.btn-like {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 25px;
}

.div_star {
    position: absolute;
    right: 20px;
    font-size: 16px;
}

.rounded-r {
    border-radius: 20px;
    position: absolute;
    right: 10px;
    top: 25px;
    width: 150px;
}

.rounded-lg {
    border-radius: 20px !important;
}

.hr_head {
    margin: 0 auto;
    width: 96%;
    border-top: 2px solid #d4d6d5;
    top: 42px;
    position: relative;
}

.hr_footer {
    margin: 0 auto;
    width: 96%;
    border-top: 2px solid #d4d6d5;
    top: 282px;
    position: relative;
}

.shadow_cal {
    box-shadow: rgba(136, 165, 191, 0.48) 5px 6px 6px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.swal2-icon.swal2-success.swal2-icon-show {
    margin-top: 120px !important;
}

.img.swal2-image {
    position: absolute;
    left: 32% !important;
}

.brd-secondary {
    margin: 1px;
    border: 2px solid #ddd;
    padding: 15px 10px 10px 10px;
    border-radius: 5px;
}

input[type='radio'] {
    accent-color: #da271b;
}

.image-upload>input {
    display: none;
}

@media (max-width: 575px) {
    .rounded {
        height: auto;
    }
}

.rounded {
    height: 150px;
    text-transform: capitalize;
}

.shadow {
    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>
